import React, { useState } from "react";
import { SelectField } from '../../ui/Field';

const LogsAnalyticsTab: React.FC<{ agent: any }> = ({ agent }) => {
    const [selectedPeriod, setSelectedPeriod] = useState('7d');
    const [logs, setLogs] = useState([
        { id: 1, timestamp: '2024-01-20 14:30:25', level: 'info', message: 'Agent response generated successfully', userId: 'user-123' },
        { id: 2, timestamp: '2024-01-20 14:28:15', level: 'warning', message: 'Fallback response triggered', userId: 'user-456' },
        { id: 3, timestamp: '2024-01-20 14:25:10', level: 'error', message: 'Integration timeout - Zendesk API', userId: 'user-789' },
        { id: 4, timestamp: '2024-01-20 14:22:05', level: 'info', message: 'Knowledge base query executed', userId: 'user-123' }
    ]);

    return (
        <div className="p-6">
            <div className="flex items-center justify-between mb-6">
                <h3 className="text-lg font-semibold text-agentic-text-primary">Logs & Analytics</h3>
                <SelectField
                    value={selectedPeriod}
                    onChange={(e) => setSelectedPeriod(e.target.value)}
                    className="px-3 py-2 border border-agentic-gray-300 rounded-lg focus:ring-2 focus:ring-agentic-primary-blue focus:border-transparent"
                >
                    <option value="1d">Last 24 hours</option>
                    <option value="7d">Last 7 days</option>
                    <option value="30d">Last 30 days</option>
                    <option value="90d">Last 90 days</option>
                </SelectField>
            </div>

            {/* Analytics Overview */}
            <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
                <div className="bg-agentic-gray-50 rounded-lg p-4">
                    <div className="text-2xl font-bold text-agentic-text-primary">1,247</div>
                    <div className="text-sm text-agentic-text-secondary">Total Requests</div>
                </div>
                <div className="bg-agentic-gray-50 rounded-lg p-4">
                    <div className="text-2xl font-bold text-agentic-accent-green">94.2%</div>
                    <div className="text-sm text-agentic-text-secondary">Success Rate</div>
                </div>
                <div className="bg-agentic-gray-50 rounded-lg p-4">
                    <div className="text-2xl font-bold text-agentic-text-primary">2.1s</div>
                    <div className="text-sm text-agentic-text-secondary">Avg Response Time</div>
                </div>
                <div className="bg-agentic-gray-50 rounded-lg p-4">
                    <div className="text-2xl font-bold text-agentic-accent-yellow">73</div>
                    <div className="text-sm text-agentic-text-secondary">Errors</div>
                </div>
            </div>

            {/* Recent Logs */}
            <div className="bg-white border rounded-lg">
                <div className="px-6 py-4 border-b border-agentic-gray-200">
                    <h4 className="font-medium text-agentic-text-primary">Recent Logs</h4>
                </div>
                <div className="divide-y divide-agentic-gray-200">
                    {logs.map((log) => (
                        <div key={log.id} className="px-6 py-3 flex items-center space-x-4">
                            <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${log.level === 'info' ? 'bg-agentic-primary-blue/10 text-agentic-primary-blue' :
                                log.level === 'warning' ? 'bg-agentic-accent-yellow/10 text-agentic-accent-yellow' :
                                    'bg-agentic-accent-red/10 text-agentic-accent-red'
                                }`}>
                                {log.level}
                            </span>
                            <span className="text-sm text-agentic-text-secondary font-mono">{log.timestamp}</span>
                            <span className="text-sm text-agentic-text-primary flex-1">{log.message}</span>
                            <span className="text-sm text-agentic-text-secondary">{log.userId}</span>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default LogsAnalyticsTab;
